// The order of the ads in this enum is the order they are checked
export enum AdType {
  MERGER = 'MERGER',
  GRAD_FAIRS = 'GRAD_FAIRS',
  SALARY_SURVEY = 'SALARY_SURVEY',
  RESUME_DB = 'RESUME_DB',
}
